import { applyExperimentsTransformer } from "./experimentsTransformer";
import { applyVariablesTransformer } from "./variablesTransformer";
import { applyResourceStringsTransformer } from "./resourceStringsTransformer";
const createVariationStringsMap = (variationStrings) => {
    const map = new Map();
    for (const [experimentKey, stringVariations] of Object.entries(variationStrings)) {
        for (const [stringKey, variations] of Object.entries(stringVariations)) {
            map.set(stringKey, [experimentKey, variations]);
        }
    }
    return map;
};
export function createLabels(config) {
    const defaultTransformers = [];
    let variationStringsMap = createVariationStringsMap({});
    if (config.experimentsConfig) {
        variationStringsMap = createVariationStringsMap(config.experimentsConfig.variationStrings);
        defaultTransformers.push(applyExperimentsTransformer(config.experimentsConfig, variationStringsMap));
    }
    defaultTransformers.push(applyResourceStringsTransformer(config.resourceStrings));
    defaultTransformers.push(applyVariablesTransformer());
    const transformers = defaultTransformers.concat(config.transformers || []);
    return {
        get(labelProps) {
            return transformers.reduce((value, transformer) => {
                return transformer(labelProps, value);
            }, labelProps.stringKey);
        },
        trigger(handlerName, labelProps) {
            if (config.handlers && typeof config.handlers[handlerName] === "function") {
                config.handlers[handlerName](labelProps);
            }
        },
        hasExperimentString(stringKey) {
            return variationStringsMap.has(stringKey);
        },
        getExperimentForString(stringKey) {
            if (!variationStringsMap.has(stringKey)) {
                return;
            }
            ;
            return variationStringsMap.get(stringKey);
        },
    };
}
//# sourceMappingURL=createLabels.js.map